import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../state/AppStore'

type Props = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
export default ({ src, ...rest }: Props) => {
	const lastUpdate = useSelector((state: RootState) => state.appConfig.imageProfileLastUpdate ?? 0)
	const avatar = useSelector((state: RootState) => state.activeUser.user?.info?.avatar)
	let newSrc: string

	if (src) {
		newSrc = src
	} else {
		newSrc = `${avatar}?${lastUpdate}`
	}

	// eslint-disable-next-line jsx-a11y/alt-text
	return <img {...rest} src={newSrc} />
}
